export default __webpack_public_path__ + "static/dalder-5709d550366dad701cd79258d50ed612.jpg";